function arrayToObject(arr: { name?: string; value?: string | string[] }[]): Record<string, string> {
  return Object.fromEntries(
    arr.map(({ name, value }) => [name, Array.isArray(value) ? value.join(', ') : value.replace(/<[^>]*>/g, '')])
  );
}

export default arrayToObject;
